import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Paneel from "../../doors/paneel";
import Schuif from "../../doors/schuif";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface DoubleSchuifDoublePanelProps extends ConfigurationProps {}
const DoubleSchuifDoublePanel: React.FC<DoubleSchuifDoublePanelProps> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: DoubleSchuifDoublePanelProps) => {
  const position0 = new Vector3(-0.459, 0, 0);
  const position1 = new Vector3(0.459, 0, 0);
  const position2 = new Vector3(1.377, 0, 0);
  const position3 = new Vector3(2.295, 0, 0);

  const { eigenwijs, getConfigurationPositions } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(
      getConfigurationPositions([position0, position1, position2, position3])
    );
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale}>
      <group scale-y={0.99}>
        <Schuif
          materials={materials}
          position={positions[0]}
          index={0}
          railSettings={doorSettings?.main?.railSettings}
          frameSettings={doorSettings?.main?.frameSettings}
        />
        <Schuif
          materials={materials}
          position={positions[1]}
          index={1}
          railSettings={doorSettings?.main?.railSettings}
        />
        <Paneel materials={materials} position={positions[2]} index={2} />
        <Paneel materials={materials} position={positions[3]} index={3} />
      </group>
    </group>
  );
};

export default DoubleSchuifDoublePanel;
